import kpiClassifyOptions from './kpiClassifyOptions';
import { watch, ref } from 'vue';
export default {
  name: 'KpiClassifySelect',
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:value'],
  setup(props, {
    emit,
    attrs
  }) {
    const kpiClassId = ref(props.value);
    const handleUpdateValue = value => {
      emit('update:value', value);
    };
    watch(() => props.value, val => {
      kpiClassId.value = val;
    }, {
      immediate: true
    });
    return {
      kpiClassifyOptions,
      attrs,
      kpiClassId,
      handleUpdateValue
    };
  }
};